"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.search.placeholder': '搜索步骤...',
};
